import React, { useState } from "react";
import "../styles/UserLogin.css";
import { useNavigate } from "react-router-dom";

export default function UserLogin() {
  const [houseId, setHouseId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(
        "http://localhost/belpimpalgaon/api/user_login.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            house_id: houseId,
            password: password,
          }),
        }
      );

      const data = await res.json();

      if (data.status === true) {
        localStorage.setItem("house_id", data.house_id);
        navigate("/user-dashboard");
      } else {
        setError("❌ चुकीचा ID किंवा Password");
      }
    } catch (err) {
      setError("❌ Server Error");
    }
  };

  return (
    <div className="user-login-container">
      <div className="login-card">
        <h2>🏠 घरधारक लॉगिन</h2>
        <p>पाणीपट्टी भरण्यासाठी लॉगिन करा</p>

        {error && <div className="error">{error}</div>}

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="House ID"
            value={houseId}
            onChange={(e) => setHouseId(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}
